<template>
  <v-card class="channel-tabs-card" data-testid="channel-tabs" :data-dense="dense ? 'true' : null">
    <v-tabs show-arrows hide-slider :model-value="modelValue" @update:modelValue="onChange">
      <v-tooltip v-for="(tab, index) in tabs" :key="tab.value" location="bottom">
        <template #activator="{ props }">
          <v-tab
            v-bind="props"
            :value="index"
            class="channel-tab"
            :class="{ 'channel-tab--active': index === modelValue, 'channel-tab--dense': dense }"
            :style="{ '--tab-color': getColor(tab.value) }"
            :data-testid="'channel-tab-' + tab.value"
            :data-active="index === modelValue ? 'true' : 'false'"
          >
            <img v-if="logoSrc(tab)" :src="logoSrc(tab)" :width="dense ? 20 : 24" :height="dense ? 20 : 24" :alt="tab.text" class="channel-tab__logo" />
            <span v-else class="channel-tab__logo channel-tab__logo--fallback">{{ (tab.text || tab.value || '').charAt(0) }}</span>
            <span v-if="!dense" class="channel-tab__label">{{ tab.text }}</span>
            <span
              class="channel-tab__pill"
              :class="{ 'is-unread': tab.unreadCount > 0 }"
              :data-testid="'channel-tab-pill-' + tab.value"
              :data-kind="tab.unreadCount > 0 ? 'unread' : 'total'"
            >{{ pillValue(tab) }}</span>
          </v-tab>
        </template>
        {{ dense ? tab.text + ' · ' : '' }}{{ $t('_unreadOfTotal', { u: tab.unreadCount || 0, t: tab.totalCount || 0 }) }}
      </v-tooltip>
    </v-tabs>
  </v-card>
</template>

<script>
// S14-P4 Wave 5 — channel tab strip for /ChatService (D12: logic lives here, not in ChatService.vue)
// No API / SignalR / asset imports: parent supplies `getLogo` / `getColor`.
export default {
  name: 'ChannelTabs',
  props: {
    tabs: { type: Array, default: () => [] }, // [{ text, value, typeSocial?, unreadCount, totalCount? }]
    modelValue: { type: Number, default: 0 }, // selected index
    getLogo: { type: Function, required: true }, // (socialType) => src | null
    getColor: { type: Function, required: true }, // (socialType) => hex
    dense: { type: Boolean, default: false }, // <1024 (U4)
  },
  emits: ['update:modelValue'],
  methods: {
    onChange(v) {
      if (typeof v === 'number') this.$emit('update:modelValue', v);
    },
    logoSrc(tab) {
      return this.getLogo ? this.getLogo(tab.value) : null;
    },
    pillValue(tab) {
      return tab.unreadCount > 0 ? tab.unreadCount : tab.totalCount || 0;
    },
  },
};
</script>

<style scoped>
.channel-tabs-card {
  box-shadow: none;
  border: 1px solid #e0e0e0;
  border-radius: 15px;
}
/* v-tabs default 48px ตัดแถบ 64px + margin 8px (ALL-W6-A TC-19 visual) */
.channel-tabs-card :deep(.v-tabs) {
  --v-tabs-height: 80px;
  height: 80px;
}
.channel-tabs-card[data-dense='true'] :deep(.v-tabs) {
  --v-tabs-height: 68px;
  height: 68px;
}
.channel-tab.v-tab.v-tab {
  min-width: 112px;
  height: 64px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  margin: 8px 4px;
  text-transform: none;
  flex-direction: column;
  position: relative;
  color: #171717;
}
.channel-tab--dense.v-tab.v-tab {
  min-width: 64px;
  height: 52px;
}
.channel-tab--active.v-tab.v-tab {
  border-color: var(--tab-color);
  background: #f5f5f5;
  background: color-mix(in srgb, var(--tab-color) 8%, white);
}
.channel-tab--active .channel-tab__label {
  color: var(--tab-color);
}
.channel-tab__label {
  font-size: 12px;
  margin-top: 4px;
}
.channel-tab__pill {
  position: absolute;
  top: 6px;
  right: 8px;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  font-size: 11px;
  line-height: 18px;
  background: #eeeeee;
  color: #171717;
}
.channel-tab__pill.is-unread {
  background: #c32e0e;
  color: #fff;
}
.channel-tab__logo--fallback {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #eeeeee;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
